import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Host, HostBinding, Input, Output } from '@angular/core';
import { BeeControllerComponent } from '../../bee-controller/bee-controller.component';
import { DimensionsListenerDirective } from '@games/shared/game-dynamic-blocks/dimensions-listener.directive';

const BORDER_COEF = 0.005;

@Component({
  selector: 'ms-bee-table',
  templateUrl: './bee-table.component.html',
  styleUrls: ['./bee-table.component.scss'],
  imports: [CommonModule],
  hostDirectives: [DimensionsListenerDirective],
})
export class BeeTableComponent {
  @HostBinding('style.border-width.px')
  get borderSize() {
    return this.gapSize * 1.5;
  }

  @HostBinding('style.gap.px')
  gapSize: number = 1;

  public xCord: number[];

  public yCord: number[];

  /** Недоступно нажатие на клетки. */
  @Input() disabled: boolean = false;

  @Input()
  public beePosition: {
    x: number;
    y: number;
  } = {
    x: 0,
    y: 0,
  };

  private _size: number;

  @Input()
  public get size(): number {
    return this._size;
  }

  public set size(value: number) {
    this._size = value;

    const tableSize = BeeControllerComponent.tableSizesMatching[value];

    this.xCord = [];
    this.yCord = [];
    for (let i = 0; i < tableSize; i++) {
      this.xCord.push(i);
      this.yCord.push(i);
    }
  }

  @Output() cellClickEmitter = new EventEmitter();

  public onCellClick(x: number, y: number): void {
    if (!this.disabled) {
      this.cellClickEmitter.next({ x, y });
    }
  }

  constructor(private readonly dimensionsListener: DimensionsListenerDirective) {
    this.dimensionsListener.sizeChanges.subscribe((res) => {
      this.gapSize = Math.max(1, Math.min(res.height, res.width) * BORDER_COEF);
    });
  }
}
